import { GridHelper } from 'three';
import Model3d from './model';
import { globalStores } from '@/editor/stores';
import { pixelRatio3d } from '@/editor/math/const';
import { groundGridColor } from '@/editor/constant/entity';

class GroundModel extends Model3d {
  constructor(id: string) {
    super(id);

    globalStores.editorStateStore.sceneInfo.scene3d.scene.add(this.model);
  }

  createModel() {
    this.clearModel();

    // 添加网格辅助
    const gridHelper = new GridHelper(2000, pixelRatio3d * 4, groundGridColor, groundGridColor);
    gridHelper.rotation.x = Math.PI / 2;
    gridHelper.position.z = -0.001;
    gridHelper.material.depthTest = true;
    gridHelper.material.depthWrite = false; // 不写入深度缓冲区，其他物体可以遮挡地面网格
    this.model.add(gridHelper);
  }
}

export default GroundModel;
